// useDueDate.js — refactor 2026-05-21.
//
// Hook fetch YearlyDueDate cho 1 năm học + module ("student" | "internal").
//
// Khác với `containers/StudentProject/utils/useDueWindow.js` (SR-only, kèm
// helper `check()` cho window guard form submit), hook này CHỈ TRẢ raw
// dueDate object — dùng cho list table compute deadline filter.
//
// Cache local đơn giản theo (type, year) — list table refetch khi đổi năm
// thường ít.

import { useEffect, useState } from "react";
import { apiCall } from "./api";
import { API_URLS } from "../constants/api";

export default function useDueDate(type, year, reloadKey = 0) {
  const [dueDate, setDueDate] = useState(null);
  const [loaded, setLoaded] = useState(false);

  // reloadKey — user-controlled bump để force refetch ngoài phạm vi
  // (type, year). Parent quản lý 1 counter `reloadKey`, bump khi user click
  // Reload trên toolbar → hook fetch lại dueDate cùng pha với list refresh.
  // Mặc định 0 → behavior cũ (refetch chỉ khi type/year đổi).
  useEffect(() => {
    let cancel = false;
    if (!type || !year) {
      setDueDate(null);
      setLoaded(true);
      return;
    }
    setLoaded(false);
    const run = async () => {
      try {
        const api = API_URLS.YEARLY_DUE_DATE.filterYearlyDueDate();
        const { response, error } = await apiCall({
          ...api,
          payload: { type, schoolYear: year },
        });
        if (cancel) return;
        if (!error && response.status === 200 && response.data?.success) {
          setDueDate(response.data.data?.[0] || null);
        } else {
          setDueDate(null);
        }
      } finally {
        if (!cancel) setLoaded(true);
      }
    };
    run();
    return () => {
      cancel = true;
    };
  }, [type, year, reloadKey]);

  return { dueDate, loaded };
}
